import { registerView, View } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Check } from "@frui.ts/bootstrap";
import ReactMarkdown from "react-markdown";
import { Col, Form } from "react-bootstrap";
import ChargeManagementActiveChargeLicensePlateChangeViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementActiveChargeLicensePlateChangeViewModel";
import ChargeManagementBeforeValidChargeLicensePlateChangeViewModel from "viewModels/chargeManagement/chargeManagementEdit/chargeManagementBeforeValidChargeLicensePlateChangeViewModel";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";

export const LicensePlateChangeView: FunctionComponent<{
  vm: ChargeManagementBeforeValidChargeLicensePlateChangeViewModel | ChargeManagementActiveChargeLicensePlateChangeViewModel;
}> = observer(({ vm }) => (
  <>
    {vm.originalVehicleInfoViewModel && <View vm={vm.originalVehicleInfoViewModel} />}
    {vm.newVehicleInfoViewModel && <View vm={vm.newVehicleInfoViewModel} />}
    <div className="mt-n3 mb-5">
      {vm.validChargesInfo && (
        <AlertWithInfoIcon variant="warning">
          <strong className="font-size-sm">
            <ReactMarkdown className="markdown">{vm.validChargesInfo}</ReactMarkdown>
          </strong>
        </AlertWithInfoIcon>
      )}
      {vm.exemptionInfo && (
        <AlertWithInfoIcon variant="warning">
          <strong className="font-size-sm">{vm.exemptionInfo}</strong>
        </AlertWithInfoIcon>
      )}
    </div>
    {vm.emailInputViewModel && <View vm={vm.emailInputViewModel} />}
    {vm instanceof ChargeManagementActiveChargeLicensePlateChangeViewModel && (
      <Form.Row>
        <Form.Group as={Col}>
          <Check
            autoComplete="off"
            custom
            target={vm.request}
            property={"_agreement"}
            label={vm.translate("vehicleChangeDuringValidity.agreement")}
          />
          {vm.agreementError && (
            <div className="d-flex justify-content-center bg-danger-light mt-3 p-2 py-0 font-size-sm font-weight-bold text-danger">
              <Icon className="mr-2" icon={IconType.InvertedError} height={18} width={18} />
              <span>{vm.translate("alertAgreement")}</span>
            </div>
          )}
        </Form.Group>
      </Form.Row>
    )}
  </>
));

registerView(LicensePlateChangeView, ChargeManagementBeforeValidChargeLicensePlateChangeViewModel);
registerView(LicensePlateChangeView, ChargeManagementActiveChargeLicensePlateChangeViewModel);
